var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticStyle:{"cursor":"pointer"},attrs:{"src":require("@/assets/edit_pencil.svg")},on:{"click":_vm.handleClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }